export class StoreDefaultLanguage {
  static readonly type = '[Default Language] Store Default Language';
  constructor(public code: string, public languageId: number) {}
}
